import controller from './invalid.controller';

export default {
  bindings: {
    packet: '<',
    msisdn: '=',
    valid: '='
  },
  controller,
  template: require('./invalid.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/buy/invalid/invalid.component.ts